import { makeRequest } from 'utils/requestLogger';

export default (id, payload) =>
  makeRequest('put', `/api/submissions/${id}/select-feedback`, payload);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/grades/selectAutomatedFeedback.js